/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.


import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';

import { BYOCWrapper, FEaaSWrapper } from '@sitecore-jss/sitecore-jss-nextjs';
import { Form } from '@sitecore-jss/sitecore-jss-nextjs';

import * as FEAASScripts from 'src/components/FEAASScripts';
import * as MotionPointScripts from 'src/components/MotionPointScripts';
import * as ToggleContentScript from 'src/components/ToggleContentScript';
import * as AccordionCollection from 'src/components/authorable/AccordionCollection/AccordionCollection';
import * as ActionTileCollection from 'src/components/authorable/ActionTileCollection/ActionTileCollection';
import * as AdvisorProfile from 'src/components/authorable/AdvisorProfile/AdvisorProfile';
import * as AlertNotice from 'src/components/authorable/AlertNotice/AlertNotice';
import * as Anchor from 'src/components/authorable/Anchor/Anchor';
import * as AppBanner from 'src/components/authorable/AppBanner/AppBanner';
import * as Article from 'src/components/authorable/Article/Article';
import * as ArticleDynamicCollection from 'src/components/authorable/ArticleDynamicCollection/ArticleDynamicCollection';
import * as ArticleSection from 'src/components/authorable/ArticleSection/ArticleSection';
import * as AuthorDetailsCard from 'src/components/authorable/AuthorDetailsCard/AuthorDetailsCard';
import * as BankerProfile from 'src/components/authorable/BankerProfile/BankerProfile';
import * as Breadcrumbgraphql from 'src/components/authorable/Breadcrumbs/Breadcrumb.graphql';
import * as Breadcrumbs from 'src/components/authorable/Breadcrumbs/Breadcrumbs';
import * as Breadcrumbstypes from 'src/components/authorable/Breadcrumbs/Breadcrumbs.types';
import * as BulletedList from 'src/components/authorable/BulletedList/BulletedList';
import * as CTACollection from 'src/components/authorable/CTACollection/CTACollection';
import * as Calculator from 'src/components/authorable/Calculator/Calculator';
import * as CarouselMarquee from 'src/components/authorable/CarouselMarquee/CarouselMarquee';
import * as CarouselMarqueeArrowButton from 'src/components/authorable/CarouselMarquee/CarouselMarqueeArrowButton';
import * as CarouselMarqueeDotButton from 'src/components/authorable/CarouselMarquee/CarouselMarqueeDotButton';
import * as CategoryTitle from 'src/components/authorable/CategoryTitle/CategoryTitle';
import * as CodeEmbedding from 'src/components/authorable/CodeEmbedding/CodeEmbedding';
import * as CopyBlock from 'src/components/authorable/CopyBlock/CopyBlock';
import * as ExpertDetailsCard from 'src/components/authorable/ExpertDetailsCard/ExpertDetailsCard';
import * as ExpertsSearch from 'src/components/authorable/ExpertsSearch/ExpertsSearch';
import * as Faq from 'src/components/authorable/Faq/Faq';
import * as FeaturedProfile from 'src/components/authorable/FeaturedProfile/FeaturedProfile';
import * as FeaturedResource from 'src/components/authorable/FeaturedResource/FeaturedResource';
import * as Footergraphql from 'src/components/authorable/Footer/Footer.graphql';
import * as Footer from 'src/components/authorable/Footer/Footer';
import * as FooterDisclaimer from 'src/components/authorable/FooterDisclaimer/FooterDisclaimer';
import * as FooterNavigationgraphql from 'src/components/authorable/FooterNavigation/FooterNavigation.graphql';
import * as FooterNavigation from 'src/components/authorable/FooterNavigation/FooterNavigation';
import * as FooterSocialNavigationgraphql from 'src/components/authorable/FooterSocialNavigation/FooterSocialNavigation.graphql';
import * as FooterSocialNavigation from 'src/components/authorable/FooterSocialNavigation/FooterSocialNavigation';
import * as FullWidthCard from 'src/components/authorable/FullWidthCard/FullWidthCard';
import * as Headergraphql from 'src/components/authorable/Header/Header.graphql';
import * as Header from 'src/components/authorable/Header/Header';
import * as Headline from 'src/components/authorable/Headline/Headline';
import * as Hero from 'src/components/authorable/Hero/Hero';
import * as HorizontalSharebar from 'src/components/authorable/HorizontalSharebar/HorizontalSharebar';
import * as EmblaCarouselDotButton from 'src/components/authorable/InfoCards/EmblaCarouselDotButton';
import * as InfoCards from 'src/components/authorable/InfoCards/InfoCards';
import * as Infographic from 'src/components/authorable/Infographic/Infographic';
import * as InterstitialCallToActionModal from 'src/components/authorable/InterstitialCallToActionModal/InterstitialCallToActionModal';
import * as JumpTo from 'src/components/authorable/JumpTo/JumpTo';
import * as LeftNavigationgraphql from 'src/components/authorable/LeftNavigation/LeftNavigation.graphql';
import * as LeftNavigation from 'src/components/authorable/LeftNavigation/LeftNavigation';
import * as LinkChips from 'src/components/authorable/LinkChips/LinkChips';
import * as LinkListCollection from 'src/components/authorable/LinkListCollection/LinkListCollection';
import * as LocationBanner from 'src/components/authorable/LocationBanner/LocationBanner';
import * as LocationModal from 'src/components/authorable/LocationModal/LocationModal';
import * as DistanceFilter from 'src/components/authorable/Locations/DistanceFilter';
import * as LocationList from 'src/components/authorable/Locations/LocationList';
import * as LocationMapSVGs from 'src/components/authorable/Locations/LocationMapSVGs';
import * as LocationSearch from 'src/components/authorable/Locations/LocationSearch';
import * as LocationTypes from 'src/components/authorable/Locations/LocationTypes';
import * as Locations from 'src/components/authorable/Locations/Locations';
import * as Login from 'src/components/authorable/Login/Login';
import * as LoginHawkeye from 'src/components/authorable/LoginHawkeye/LoginHawkeye';
import * as LoginMultiplex from 'src/components/authorable/LoginMultiplex/LoginMultiplex';
import * as LoginSuperman from 'src/components/authorable/LoginSuperman/LoginSuperman';
import * as LongArticle from 'src/components/authorable/LongArticle/LongArticle';
import * as LongArticleHero from 'src/components/authorable/LongArticleHero/LongArticleHero';
import * as MinimalHeader from 'src/components/authorable/MinimalHeader/MinimalHeader';
import * as Modal from 'src/components/authorable/Modal/Modal';
import * as MultiVideoPlayerModule from 'src/components/authorable/MultiVideoPlayerModule/MultiVideoPlayerModule';
import * as NavigationMenugraphql from 'src/components/authorable/NavigationMenu/NavigationMenu.graphql';
import * as NavigationMenu from 'src/components/authorable/NavigationMenu/NavigationMenu';
import * as PageTitle from 'src/components/authorable/PageTitle/PageTitle';
import * as CustomProduct from 'src/components/authorable/ProductComparisonChart/CustomProduct';
import * as ProductComparisonChart from 'src/components/authorable/ProductComparisonChart/ProductComparisonChart';
import * as ProductComparisonSlider from 'src/components/authorable/ProductComparisonChart/ProductComparisonSlider';
import * as ProductSliderWrapper from 'src/components/authorable/ProductComparisonChart/ProductSliderWrapper';
import * as CarouselProfileArrowButton from 'src/components/authorable/Profiles/CarouselProfileArrowButton';
import * as CarouselProfileDotButton from 'src/components/authorable/Profiles/CarouselProfileDotButton';
import * as Profiles from 'src/components/authorable/Profiles/Profiles';
import * as ProgressiveGrid from 'src/components/authorable/ProgressiveGrid/ProgressiveGrid';
import * as PromoBox from 'src/components/authorable/PromoBox/PromoBox';
import * as MortgageRates from 'src/components/authorable/Rates/MortgageRates/MortgageRates';
import * as MultiUseRates from 'src/components/authorable/Rates/MultiUseRates/MultiUseRates';
import * as RatesGroupCalculator from 'src/components/authorable/Rates/RatesGroupCalculator/RatesGroupCalculator';
import * as RelatedResources from 'src/components/authorable/RelatedResources/RelatedResources';
import * as ResourceLibrary from 'src/components/authorable/ResourceLibrary/ResourceLibrary';
import * as ResourceSearch from 'src/components/authorable/ResourceSearch/ResourceSearch';
import * as Sharebar from 'src/components/authorable/Sharebar/Sharebar';
import * as SingleLineMarketingPromo from 'src/components/authorable/SingleLineMarketingPromo/SingleLineMarketingPromo';
import * as SlideshowCollection from 'src/components/authorable/SlideshowCollection/SlideshowCollection';
import * as SlideshowSlider from 'src/components/authorable/SlideshowCollection/SlideshowSlider';
import * as SplitColumnLayout from 'src/components/authorable/SplitColumnLayout/SplitColumnLayout';
import * as SplitColumnLayoutTypeshelper from 'src/components/authorable/SplitColumnLayout/SplitColumnLayoutTypes.helper';
import * as StatsList from 'src/components/authorable/StatsList/StatsList';
import * as TableofContents from 'src/components/authorable/TableofContents/TableofContents';
import * as TabsCollection from 'src/components/authorable/TabsCollection/TabsCollection';
import * as TitleCopy from 'src/components/authorable/TitleCopy/TitleCopy';
import * as Topics from 'src/components/authorable/Topics/Topics';
import * as TrendingTopics from 'src/components/authorable/TrendingTopics/TrendingTopics';
import * as Video from 'src/components/authorable/Video/Video';
import * as VideoBlock from 'src/components/authorable/VideoBlock/VideoBlock';
import * as VideoCallToAction from 'src/components/authorable/VideoCallToAction/VideoCallToAction';
import * as VisualSitemap from 'src/components/authorable/VisualSitemap/VisualSitemap';
import * as CdpPageView from 'src/components/default/CdpPageView';
import * as ColumnSplitter from 'src/components/default/ColumnSplitter';
import * as Container from 'src/components/default/Container';
import * as ContentBlock from 'src/components/default/ContentBlock';
import * as Image from 'src/components/default/Image';
import * as LinkList from 'src/components/default/LinkList';
import * as Navigation from 'src/components/default/Navigation';
import * as PageContent from 'src/components/default/PageContent';
import * as PartialDesignDynamicPlaceholder from 'src/components/default/PartialDesignDynamicPlaceholder';
import * as Promo from 'src/components/default/Promo';
import * as RichText from 'src/components/default/RichText';
import * as RowSplitter from 'src/components/default/RowSplitter';
import * as Title from 'src/components/default/Title';
import * as BankerProfileSearch from 'src/components/search/BankerProfileSearch/BankerProfileSearch';
import * as EnhancedSearch from 'src/components/search/EnhancedSearch/EnhancedSearch';
import * as EnhancedSearchLanding from 'src/components/search/EnhancedSearchLanding/EnhancedSearchLanding';
import * as Search from 'src/components/search/Search/Search';
import * as SearchOverlay from 'src/components/search/SearchOverlay/SearchOverlay';
import * as SearchwithFilter from 'src/components/search/SearchwithFilter/SearchwithFilter';

export const components = new Map();
components.set('BYOCWrapper', BYOCWrapper);
components.set('FEaaSWrapper', FEaaSWrapper);
components.set('Form', Form);

components.set('FEAASScripts', FEAASScripts);
components.set('MotionPointScripts', MotionPointScripts);
components.set('ToggleContentScript', ToggleContentScript);
components.set('AccordionCollection', AccordionCollection);
components.set('ActionTileCollection', ActionTileCollection);
components.set('AdvisorProfile', AdvisorProfile);
components.set('AlertNotice', AlertNotice);
components.set('Anchor', Anchor);
components.set('AppBanner', AppBanner);
components.set('Article', Article);
components.set('ArticleDynamicCollection', ArticleDynamicCollection);
components.set('ArticleSection', ArticleSection);
components.set('AuthorDetailsCard', AuthorDetailsCard);
components.set('BankerProfile', BankerProfile);
components.set('Breadcrumb.graphql', Breadcrumbgraphql);
components.set('Breadcrumbs', Breadcrumbs);
components.set('Breadcrumbs.types', Breadcrumbstypes);
components.set('BulletedList', BulletedList);
components.set('CTACollection', CTACollection);
components.set('Calculator', Calculator);
components.set('CarouselMarquee', CarouselMarquee);
components.set('CarouselMarqueeArrowButton', CarouselMarqueeArrowButton);
components.set('CarouselMarqueeDotButton', CarouselMarqueeDotButton);
components.set('CategoryTitle', CategoryTitle);
components.set('CodeEmbedding', CodeEmbedding);
components.set('CopyBlock', CopyBlock);
components.set('ExpertDetailsCard', ExpertDetailsCard);
components.set('ExpertsSearch', ExpertsSearch);
components.set('Faq', Faq);
components.set('FeaturedProfile', FeaturedProfile);
components.set('FeaturedResource', FeaturedResource);
components.set('Footer.graphql', Footergraphql);
components.set('Footer', Footer);
components.set('FooterDisclaimer', FooterDisclaimer);
components.set('FooterNavigation.graphql', FooterNavigationgraphql);
components.set('FooterNavigation', FooterNavigation);
components.set('FooterSocialNavigation.graphql', FooterSocialNavigationgraphql);
components.set('FooterSocialNavigation', FooterSocialNavigation);
components.set('FullWidthCard', FullWidthCard);
components.set('Header.graphql', Headergraphql);
components.set('Header', Header);
components.set('Headline', Headline);
components.set('Hero', Hero);
components.set('HorizontalSharebar', HorizontalSharebar);
components.set('EmblaCarouselDotButton', EmblaCarouselDotButton);
components.set('InfoCards', InfoCards);
components.set('Infographic', Infographic);
components.set('InterstitialCallToActionModal', InterstitialCallToActionModal);
components.set('JumpTo', JumpTo);
components.set('LeftNavigation.graphql', LeftNavigationgraphql);
components.set('LeftNavigation', LeftNavigation);
components.set('LinkChips', LinkChips);
components.set('LinkListCollection', LinkListCollection);
components.set('LocationBanner', LocationBanner);
components.set('LocationModal', LocationModal);
components.set('DistanceFilter', DistanceFilter);
components.set('LocationList', LocationList);
components.set('LocationMapSVGs', LocationMapSVGs);
components.set('LocationSearch', LocationSearch);
components.set('LocationTypes', LocationTypes);
components.set('Locations', Locations);
components.set('Login', Login);
components.set('LoginHawkeye', LoginHawkeye);
components.set('LoginMultiplex', LoginMultiplex);
components.set('LoginSuperman', LoginSuperman);
components.set('LongArticle', LongArticle);
components.set('LongArticleHero', LongArticleHero);
components.set('MinimalHeader', MinimalHeader);
components.set('Modal', Modal);
components.set('MultiVideoPlayerModule', MultiVideoPlayerModule);
components.set('NavigationMenu.graphql', NavigationMenugraphql);
components.set('NavigationMenu', NavigationMenu);
components.set('PageTitle', PageTitle);
components.set('CustomProduct', CustomProduct);
components.set('ProductComparisonChart', ProductComparisonChart);
components.set('ProductComparisonSlider', ProductComparisonSlider);
components.set('ProductSliderWrapper', ProductSliderWrapper);
components.set('CarouselProfileArrowButton', CarouselProfileArrowButton);
components.set('CarouselProfileDotButton', CarouselProfileDotButton);
components.set('Profiles', Profiles);
components.set('ProgressiveGrid', ProgressiveGrid);
components.set('PromoBox', PromoBox);
components.set('MortgageRates', MortgageRates);
components.set('MultiUseRates', MultiUseRates);
components.set('RatesGroupCalculator', RatesGroupCalculator);
components.set('RelatedResources', RelatedResources);
components.set('ResourceLibrary', ResourceLibrary);
components.set('ResourceSearch', ResourceSearch);
components.set('Sharebar', Sharebar);
components.set('SingleLineMarketingPromo', SingleLineMarketingPromo);
components.set('SlideshowCollection', SlideshowCollection);
components.set('SlideshowSlider', SlideshowSlider);
components.set('SplitColumnLayout', SplitColumnLayout);
components.set('SplitColumnLayoutTypes.helper', SplitColumnLayoutTypeshelper);
components.set('StatsList', StatsList);
components.set('TableofContents', TableofContents);
components.set('TabsCollection', TabsCollection);
components.set('TitleCopy', TitleCopy);
components.set('Topics', Topics);
components.set('TrendingTopics', TrendingTopics);
components.set('Video', Video);
components.set('VideoBlock', VideoBlock);
components.set('VideoCallToAction', VideoCallToAction);
components.set('VisualSitemap', VisualSitemap);
components.set('CdpPageView', CdpPageView);
components.set('ColumnSplitter', ColumnSplitter);
components.set('Container', Container);
components.set('ContentBlock', ContentBlock);
components.set('Image', Image);
components.set('LinkList', LinkList);
components.set('Navigation', Navigation);
components.set('PageContent', PageContent);
components.set('PartialDesignDynamicPlaceholder', PartialDesignDynamicPlaceholder);
components.set('Promo', Promo);
components.set('RichText', RichText);
components.set('RowSplitter', RowSplitter);
components.set('Title', Title);
components.set('BankerProfileSearch', BankerProfileSearch);
components.set('EnhancedSearch', EnhancedSearch);
components.set('EnhancedSearchLanding', EnhancedSearchLanding);
components.set('Search', Search);
components.set('SearchOverlay', SearchOverlay);
components.set('SearchwithFilter', SearchwithFilter);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
